/**
 * 文件存储服务接口
 * 用于在上传和识别阶段之间缓存文件
 */
export interface FileStorageService {
    /**
     * 存储文件
     * @param fileId 文件ID
     * @param file 文件对象
     */
    storeFile(fileId: string, file: File): void;

    /**
     * 获取存储的文件
     * @param fileId 文件ID
     * @returns 文件对象，如果不存在则返回undefined
     */
    getFile(fileId: string): File | undefined;

    /**
     * 移除存储的文件
     * @param fileId 文件ID
     */
    removeFile(fileId: string): void;

    /**
     * 清除所有存储的文件
     */
    clear(): void;

    /**
     * 获取存储的文件数量
     */
    size(): number;
}

/**
 * 文件存储服务绑定标识
 */
export const FileStorageService = Symbol.for('FileStorageService');
